export const EventDetailsTableFilters = [
  // i. Event Type
  {
    key: "eventType",
    tabs: [0],
    type: "static",
    label: "Event Type",
    staticData: [
      { id: "charging", value: "Charging" },
      { id: "discharging", value: "Discharging" },
      { id: "idle", value: "Idle" },
    ],
    displayType: "multiSelectDropdown",
  },
  // ii. Charge Type
  {
    key: "chargeType",
    tabs: [0],
    type: "static",
    label: "Charge Type",
    staticData: [
      { id: "fast", value: "Fast" },
      { id: "slow", value: "Slow" },
    ],
    displayType: "multiSelectDropdown",
  },
  // iii. Duration - min and max in minutes
  {
    key: "durationMinutes",
    tabs: [0],
    type: "static",
    label: "Duration",
    staticData: [
      {
        max: 99999,
        min: 0,
      },
    ],
    displayType: "range",
    unitOfMeasurement: "minutes",
  },
  // iv. Start SOC % - min and max value
  {
    key: "startSoc",
    tabs: [0],
    type: "static",
    label: "Start SOC %",
    staticData: [
      {
        max: 100,
        min: 0,
      },
    ],
    displayType: "range",
    unitOfMeasurement: "%",
  },
  // v. End SOC % - min and max value
  {
    key: "endSoc",
    tabs: [0],
    type: "static",
    label: "End SOC %",
    staticData: [
      {
        max: 100,
        min: 0,
      },
    ],
    displayType: "range",
    unitOfMeasurement: "%",
  },
  // vi. Data Gap % - min and max value
  {
    key: "dataGapPercent",
    tabs: [0],
    type: "static",
    label: "Data Gap %",
    staticData: [
      {
        max: 100,
        min: 0,
      },
    ],
    displayType: "range",
    unitOfMeasurement: "%",
  },
  // vii. Charge Energy Consumption - min and max value
  {
    key: "chargeEnergyConsumed",
    tabs: [0],
    type: "static",
    label: "BMS Charge Energy",
    staticData: [
      {
        max: 999999,
        min: 0,
      },
    ],
    displayType: "range",
    unitOfMeasurement: "kWh",
  },
  // viii. Calculated Charge Energy - min and max value
  {
    key: "calculatedChargeEnergy",
    tabs: [0],
    type: "static",
    label: "Calculated Charge Energy",
    staticData: [
      {
        max: 999999,
        min: 0,
      },
    ],
    displayType: "range",
    unitOfMeasurement: "kWh",
  },
  // ix. Ideal Charging Energy - min and max values
  {
    key: "idealChargingEnergy",
    tabs: [0],
    type: "static",
    label: "Ideal Charging Energy",
    staticData: [
      {
        max: 999999,
        min: 0,
      },
    ],
    displayType: "range",
    unitOfMeasurement: "kWh",
  },
  // x. Calculated Discharge Energy - min and max values
  {
    key: "calculatedDischargeEnergy",
    tabs: [0],
    type: "static",
    label: "Calculated Discharge Energy",
    staticData: [
      {
        max: 999999,
        min: 0,
      },
    ],
    displayType: "range",
    unitOfMeasurement: "kWh",
  },
  // x-b. BMS Discharge Energy - min and max values
  {
    key: "dischargeEnergyConsumed",
    tabs: [0],
    type: "static",
    label: "BMS Discharge Energy",
    staticData: [
      {
        max: 999999,
        min: 0,
      },
    ],
    displayType: "range",
    unitOfMeasurement: "kWh",
  },
  // xi. Calculated Regen Energy - min and max values
  {
    key: "calculatedRegenEnergy",
    tabs: [0],
    type: "static",
    label: "Calculated Regen Energy",
    staticData: [
      {
        max: 999999,
        min: 0,
      },
    ],
    displayType: "range",
    unitOfMeasurement: "kWh",
  },
  // xi-a. BMS Regen Energy - min and max values
  {
    key: "regenEnergy",
    tabs: [0],
    type: "static",
    label: "BMS Regen Energy",
    staticData: [
      {
        max: 999999,
        min: 0,
      },
    ],
    displayType: "range",
    unitOfMeasurement: "kWh",
  },
  // xi-b. regen Energy % - min and max values
  {
    key: "regenEnergyPercent",
    tabs: [0],
    type: "static",
    label: "BMS Regen Energy %",
    staticData: [
      {
        max: 100,
        min: 0,
      },
    ],
    displayType: "range",
    unitOfMeasurement: "%",
  },
  // xi-c. Calculated Regen Energy % - min and max values
  {
    key: "calculatedRegenEnergyPercent",
    tabs: [0],
    type: "static",
    label: "Calculated Regen Energy %",
    staticData: [
      {
        max: 100,
        min: 0,
      },
    ],
    displayType: "range",
    unitOfMeasurement: "%",
  },
  // xii. distance km - min and max values
  {
    key: "distance",
    tabs: [0],
    type: "static",
    label: "Distance",
    staticData: [
      {
        max: 999999,
        min: 0,
      },
    ],
    displayType: "range",
    unitOfMeasurement: "km",
  },
  // xiii. kWh/km - buckets, on the same calculated value the kWh/km column shows
  {
    key: "kWhPerKmCalculated",
    tabs: [0],
    type: "static",
    label: "kWh/km",
    staticData: [
      {
        id: {
          end: 1,
          start: 0,
        },
        value: "< 1",
      },
      {
        id: {
          end: 1.25,
          start: 1,
        },
        value: "1 to 1.25 - Excellent",
      },
      {
        id: {
          end: 1.5,
          start: 1.25,
        },
        value: "1.25 to 1.5 - Good",
      },
      {
        id: {
          end: 1.75,
          start: 1.51,
        },
        value: "1.51 to 1.75 - Poor",
      },
      {
        id: {
          end: 99999,
          start: 1.75,
        },
        value: "> 1.75",
      },
    ],
    displayType: "multiSelectDropdown",
  },
  // xiv. Max Temperature - min and max values
  {
    key: "maxTemperature",
    tabs: [0],
    type: "static",
    label: "Max Temperature",
    staticData: [
      {
        max: 9999,
        min: -9999,
      },
    ],
    displayType: "range",
    unitOfMeasurement: "°C",
  },
  // xv. min temperature - min and max values
  {
    key: "minTemperature",
    tabs: [0],
    type: "static",
    label: "Min Temperature",
    staticData: [
      {
        max: 9999,
        min: -9999,
      },
    ],
    displayType: "range",
    unitOfMeasurement: "°C",
  },
  // xvi. temperature difference - min and max values
  {
    key: "temperatureDiff",
    tabs: [0],
    type: "static",
    label: "Temperature Difference",
    staticData: [
      {
        max: 9999,
        min: 0,
      },
    ],
    displayType: "range",
    unitOfMeasurement: "°C",
  },
  // xvii. bms soh % - same as inventory
  {
    key: "bmsSoh",
    tabs: [0],
    type: "static",
    label: "BMS SOH",
    subType: "range",
    staticData: [
      {
        id: {
          end: 200,
          start: 99,
        },
        value: "> 98%",
      },
      {
        id: {
          end: 98,
          start: 95,
        },
        value: "98% to 95%",
      },
      {
        id: {
          end: 94,
          start: 90,
        },
        value: "95% to 90%",
      },
      {
        id: {
          end: 89,
          start: 85,
        },
        value: "90% to 85%",
      },
      {
        id: {
          end: 84,
          start: 80,
        },
        value: "85% to 80%",
      },
      {
        id: {
          end: 79,
          start: 75,
        },
        value: "80% to 75%",
      },
      {
        id: {
          end: 74,
          start: 70,
        },
        value: "75% to 70%",
      },
    ],
    displayType: "multiSelectDropdown",
  },
];
